import { useTranslate } from "@tolgee/react";
import * as Dialog from "../ui/dialog";
import { Button } from "../ui";
import { ValidationPopupContent } from "../organisms";
import { ValidationPopupAttentionBadge } from "../atoms";

interface ValidationPopupProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  contentMessage: string;
  errorMessage: string;
  buttonText: string;
}

export const ValidationPopup = ({
  open,
  setOpen,
  title,
  contentMessage,
  errorMessage,
  buttonText,
}: ValidationPopupProps) => {
  const { t } = useTranslate();
  const titleText = title || t("validation-popup-title");
  const contentMessageText = contentMessage || t("validation-content-message");
  const errorMessageText = errorMessage || t("validation-errors-message");
  const buttonTextText = buttonText || t("button-ok");

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Content className="border border-red-600 max-w-[500px]">
        <Dialog.Header>
          <ValidationPopupAttentionBadge />
        </Dialog.Header>
        <ValidationPopupContent
          titleText={titleText}
          contentMessageText={contentMessageText}
          errorMessageText={errorMessageText}
        />
        <Dialog.Footer className="mt-5" />
        <Dialog.Close asChild className="absolute right-5 bottom-5">
          <Button color="indigo">{buttonTextText}</Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Root>
  );
};
